import { api1 } from "../utils/axiosInstance";
import { API_ENDPOINTS } from "./apiEndpoints";

export const getAllComplains = async () => {
  try {
    const response = await api1.get(API_ENDPOINTS.GET_COMPLAINS);
    return response.data;
  } catch (error) {
    console.error("Error: ", error);
  }
};

export const fetchTotalUsersAndMentors = async () => {
  try {
    const response = await api1.get(API_ENDPOINTS.FETCH_TOTAL_USERS_MENTORS);
    return response.data.data;
  } catch (error) {
    console.error("Error: ", error);
    return null;
  }
};

export const fetchUsersByCountry = async () => {
  try {
    const response = await api1.get(API_ENDPOINTS.FETCH_USERS_BY_COUNTRY);
    return response.data.data;
  } catch (error) {
    console.error("Error: ", error);
    return null;
  }
};

export const fetchAILiteracyReport = async () => {
  try {
    const response = await api1.get(API_ENDPOINTS.FETCH_AI_LITERACY_REPORT);
    return response.data;
  } catch (error) {
    console.error("Error: ", error);
    return null;
  }
};

export const fetchProficiencyRaceDistributionData = async () => {
  try {
    const response = await api1.get(API_ENDPOINTS.PROFICIENY_RACE_DATA);
    return response.data;
  } catch (error) {
    console.error("Error: ", error);
    return null;
  }
};

export const fetchProficiencyPercentageData = async () => {
  try {
    const response = await api1.get(API_ENDPOINTS.PROFICIENY_PERCENTAGE_DATA, {
      meta: { showToast: false },
    });
    return response.data.data;
  } catch (error) {
    console.error("Error: ", error);
    return null;
  }
};

export const fetchJobAutomationData = async () => {
  try {
    const response = await api1.get(API_ENDPOINTS.FETCH_JOB_AUTOMATION_DATA);
    return response.data;
  } catch (error) {
    console.error("Error: ", error);
    return null;
  }
};

export const fetchJobAutomationPercentageData = async () => {
  try {
    const response = await api1.get(
      API_ENDPOINTS.FETCH_JOB_AUTOMATION_PERCENTAGE_DATA,
      {
        meta: { showToast: false },
      }
    );
    return response.data.data;
  } catch (error) {
    console.error("Error: ", error);
    return null;
  }
};

export const fetchGenderReport = async () => {
  try {
    const response = await api1.get(API_ENDPOINTS.FETCH_GENDER_REPORT, {
      meta: { showToast: false },
    });
    return response.data;
  } catch (error) {
    console.error("Error: ", error);
    return null;
  }
};

export const fetchProficiencyGenderData = async () => {
  try {
    const response = await api1.get(API_ENDPOINTS.FETCH_PROFICIENCY_BY_GENDER, {
      meta: { showToast: false },
    });
    return response.data.data;
  } catch (error) {
    console.error("Error: ", error);
    return null;
  }
};

export const fetchAllChannels = async () => {
  try {
    const response = await api1.get(API_ENDPOINTS.GET_ALL_GROUPS);
    const allGroups = response.data?.data || {};
    const learningGroups = allGroups.learningGroups || [];
    const industryGroups = allGroups.industryGroups || [];
    
    // Transform groups to match the old channel format for compatibility
    const transformedData = [...learningGroups, ...industryGroups].map(group => ({
      _id: group._id,
      name: group.name,
      groupType: group.groupType,
      description: group.description,
      createdAt: group.createdAt,
      participants: group.participants || []
    }));
    
    return {
      success: true,
      data: transformedData
    };
  } catch (error) {
    console.error("Error fetching groups:", error);
    return { success: false, data: [] };
  }
};

export const fetchAllCourses = async () => {
  try {
    const response = await api1.get(API_ENDPOINTS.GET_ALL_COURSE);
    return response.data;
  } catch (error) {
    console.error("Error: ", error);
    return null;
  }
};

export const fetchAllCohorts = async () => {
  try {
    const response = await api1.get(API_ENDPOINTS.CHORTS);
    return response.data;
  } catch (error) {
    console.error("Error: ", error);
    return null;
  }
};

export const getUserCohorts = async (userId) => {
  try {
    const response = await api1.get(`${API_ENDPOINTS.USER_CHORTS}/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error: ", error);
    return null;
  }
};

export const fetchUsers = async (userId) => {
  try {
    const response = await api1.get(API_ENDPOINTS.FETCH_USERS);
    return response.data;
  } catch (error) {
    console.error("Error: ", error);
    return null;
  }
};

export const getUsersByQuater = async (userId) => {
  try {
    const response = await api1.get(API_ENDPOINTS.GET_USERS_BY_QUATER);
    return response.data;
  } catch (error) {
    console.error("Error: ", error);
    return null;
  }
};
